import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getUserAgentDetails as getUserAgentDetailsAPI } from 'src/common/Scraper';
import { UserAgentDetailsResponse } from '../types/user-agents.type';

/**
 * React Query hook to fetch user agent details by siteId.
 *
 * @param siteId - The site ID to retrieve agent details for
 */
export const useGetUserAgentDetails = (
  siteId: string
): UseQueryResult<UserAgentDetailsResponse, Error> => {
  return useQuery<UserAgentDetailsResponse, Error>({
    queryKey: ['getUserAgentDetails', siteId],
    queryFn: () => getUserAgentDetailsAPI(siteId),
    enabled: !!siteId,
  });
};

export default useGetUserAgentDetails;
